import { CurrencyPipe, NgClass } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms'

@Component({
  selector: 'ngx-reminder-schedule',
  templateUrl: './reminder-schedule.component.html',
  standalone: true,
  imports: [NgClass, CurrencyPipe, ReactiveFormsModule]
})
export class ReminderScheduleComponent {
  @Input()
  schedule: UntypedFormGroup
  @Input()
  isOnlySchedule = true
  @Input()
  isFirstSchedule = false
  @Output()
  removeSchedule: EventEmitter<null> = new EventEmitter()
  @Input()
  reminderPrice: { amount: number; currency: string }

  types: any

  constructor() {
    this.types = {
      minute: { maxValue: 59, text: 'minutes before' },
      hour: { maxValue: 23, text: 'hours before' },
      day: { maxValue: 0, text: 'days before' }
    }
  }
  /**
   * Keeps the amount a whole number. Decimal reminders are not a valid offset.
   */
  preventDecimalNumbersCheck() {
    this.schedule.patchValue({
      value: `${this.schedule.get('value').value}`.replace(/[^0-9]*/g, '')
    })
  }

  removeReminder() {
    if (this.schedule.value.done === false) this.removeSchedule.emit()
  }

  /**
   * First validation error on the schedule group. Templates cannot call `Object.keys`.
   * @returns {string | null}
   */
  public firstErrorKey(): string | null {
    const errors = this.schedule?.errors
    if (!errors) return null
    return Object.keys(errors)[0] ?? null
  }
}
